import firebase from 'firebase';

const getCurrentUser = (): App.User | null => {
  return firebase.auth().currentUser;
};


export default getCurrentUser;
